import api from '../api';

export const getProductModelByFiltersAndLimit = async (
	busca?: string,
	limit?: number,
	orderBy?: string,
	sort?: string,
	produto_status?: boolean
) => {
	const response = await api.get('/model-product', {
		params: {
			busca,
			limit,
			orderBy,
			sort,
			produto_status,
		},
	});
	return response.data;
};

export const getProductModelByFiltersAndLimitPage = async payload => {
	const response = await api.get('/model-product/paginado', {
		params: { ...payload },
	});
	return response.data;
};

export const deleteProductModel = async (id: string | number) => {
	const response = await api.delete(`/model-product?id=${id}`);
	return response.data;
};

export const deleteProductModelByFilters = async (filters: any) => {
	const response = await api.post('model-product/delete-by-filters', filters);
	return response.data;
};
